import React, { createContext, useContext, useState, useEffect } from 'react';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    useEffect(() => {
        if (config || isFetching) return;

        const fetchConfig = async () => {
            setIsFetching(true);
            try {
                const response = await fetch('/config.json');
                if (!response.ok) {
                    throw new Error(`Failed to fetch config: ${response.status}`);
                }
                const data = await response.json();
                setConfig(data);
            } catch (error) {
                console.error('Error fetching config:', error);
            } finally {
                setIsFetching(false);
            }
        };

        fetchConfig();
    }, [config, isFetching]);


    return (
        <ConfigContext.Provider value={config}>
            <div style={{ minHeight: 0, overflow: 'hidden' }}>
                {children}
            </div>
        </ConfigContext.Provider>
    );
};

export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (context === undefined) {
        throw new Error('useConfig must be used within a ConfigProvider');
    }
    return context;
};
